import React, { useEffect, useState } from "react";

export default function ViewAuthorizationLetter({
  isOpen,
  onClose,
  title,
  content,
  mode,
  showToolbar = false,
  certificateStatus = "ISSUED",
  isExternalVisitor = false,
}) {
  const [isPdfLoading, setIsPdfLoading] = useState(true);
  const [isQrLoading, setIsQrLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      setIsPdfLoading(true);
      setIsQrLoading(true);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="custom-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="custom-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="custom-modal-header">
          <h5 className="modal-title m-3">{title || "Authorization Letter"}</h5>

          <div className="modal-actions">
            <button className="close-btn" onClick={onClose}>
              &times;
            </button>
          </div>
        </div>

        <div className="custom-modal-body">
          {mode === "pdf" ? (
            isExternalVisitor && certificateStatus === "EXPIRED" ? (
              <div className="pdf-contact">
                <i className="fa fa-circle-exclamation mr-2" />
                <span>For details of the record, kindly contact RRPL service team.</span>
              </div>
            ) : content ? (
              <div className="pdf-container">
                {isPdfLoading && (
                  <div className="pdf-loader center">
                    <i className="fa fa-spinner fa-spin fa-2x text-deep-blue" />
                    <div>Loading PDF...</div>
                  </div>
                )}
                <iframe
                  src={showToolbar ? content : `${content}#toolbar=0&navpanes=0&scrollbar=0`}
                  title="PDF Viewer"
                  className="pdf-iframe"
                  onLoad={() => setIsPdfLoading(false)}
                />
              </div>
            ) : (
              <div className="pdf-error">No authorization letter available</div>
            )
          ) : mode === "qr" ? (
            content ? (
              <div className="qr-container">
                {isQrLoading && (
                  <div className="qr-loader center">
                    <i className="fa fa-spinner fa-spin fa-2x text-deep-blue" />
                    <div>Loading QR...</div>
                  </div>
                )}

                <img
                  src={content}
                  alt="QR Viewer"
                  className="qr-iframe"
                  onLoad={() => setIsQrLoading(false)}
                />
              </div>
            ) : (
              <div className="pdf-error">No QR code available</div>
            )
          ) : (
            <div className="pdf-error">
              No authorization letter or QR code available
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
